/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import { Property } from 'csstype';
import * as React from 'react';
import { Page } from 'src/core/components/Page';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylist } from 'src/core/themes/luisStylist';
import { globalMessages } from 'src/core/utils/globalMessages';

const { styleComponent } = getStylist('BlankPage');

const FullPageContainer = styleComponent<IStackProps>(Stack)('FullPageContainer', theme => ({
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.pageBackgroundColor,
    zIndex: theme.pageZIndex as Property.ZIndex
}));

/**
 * A blank white page used to cover authentication redirect
 * tearing when signing in to a tenant.
 *
 * @see authFlow.md for more details.
 */
export const BlankPage = () => {
    const { localize } = useLocalization();

    return (
        <FullPageContainer verticalFill>
            <Page size="container-fluid" title={localize(globalMessages.loading)} pageName={null} />
        </FullPageContainer>
    );
};
